/* eslint-disable sort-keys-fix/sort-keys-fix */
import { ENV_MEDIA_DOMAIN } from '@lib/core/service/consts';
import { TColorShadeKey } from '@lib/tools/shared/helpers/interfaces';
import { CRAFTED, HEETS, TEREA, VEEV, VEEV_ONE } from '@lib/tools/shared/pmi/retailers/consts';
// Dietary preferences
export const DIETARY_PREFERENCE_EXPOSURE = {
  MOOD: 'mood',
  PREFERENCES: 'preferences',
  TAGS: 'tags',
};

export const DIETARY_PREFERENCE_SLUG = {
  NO_DAIRY: 'no-dairy',
  NO_FOOD_PREFERENCES: 'no-food-preferences',
  NO_GLUTEN: 'no-gluten',
  NO_MEAT: 'no-meat',
  NO_PREFERENCES: 'no-preferences',
};

// Legal page subpages
export const LEGAL_PAGE_TERMS_AND_CONDITIONS_PAGE = 'terms-and-conditions';
export const LEGAL_PAGE_COOKIE_POLICY_PAGE = 'cookie-policy';
export const LEGAL_PAGE_PRIVACY_POLICY_PAGE = 'privacy-policy';

export const PRODUCT_CATEGORY_ALL = 'all';
export const PRODUCT_CATEGORY_WINE = 'wine';
export const PRODUCT_CATEGORY_BEER = 'beer';
export const PRODUCT_CATEGORY_BREAD = 'bread';
export const PRODUCT_CATEGORY_COFFEE = 'coffee';
export const PRODUCT_CATEGORY_TEA = 'tea';
export const PRODUCT_CATEGORY_OIL = 'oil';
export const PRODUCT_CATEGORY_CANDY = 'candy';
export const PRODUCT_CATEGORY_CHOCOLATE = 'chocolate';
export const PRODUCT_CATEGORY_DIGESTIF = 'digestif';
export const PRODUCT_CATEGORY_NONE = 'none';
export const PRODUCT_CATEGORY_NICOTINE_POUCHES = 'nicotine-pouches';

export const PRODUCT_CATEGORIES = {
  CRAFTED,
  HEETS,
  PRODUCT_CATEGORY_BEER,
  PRODUCT_CATEGORY_BREAD,
  PRODUCT_CATEGORY_COFFEE,
  PRODUCT_CATEGORY_NONE,
  PRODUCT_CATEGORY_WINE,
  TEREA,
  VEEV,
  VEEV_ONE,
  PRODUCT_CATEGORY_NICOTINE_POUCHES,
} as const;

export const PRODUCT_CATEGORIES_WITH_ALL = {
  ...PRODUCT_CATEGORIES,
  PRODUCT_CATEGORY_ALL,
} as const;

export const VH_RETAILER_URL_SLUG_APP = 'vh-app';

// Recipe type slugs
export const CLASSIC_RECIPE_TYPE_SLUG = 'classic';
export const HEALTHY_RECIPE_TYPE_SLUG = 'healthy';
export const INGREDIENT_RECIPE_TYPE_SLUG = 'ingredient';

export const PROMOTION_LABEL_SLUG = 'label';
export const PROMOTION_BADGE_FIDELITY = 'bottom-badge-fidelity';
export const PROMOTION_BADGE_PROMOTION = 'bottom-badge-promotion';
export const PROMOTION_BADGE_OTHER = 'bottom-badge-other';

export enum FidelityModalsTypes {
  NotFoundCard = 1,
  SuccessWithCharacter,
  SuccessWithoutCharacter,
  CardDisconnected,
  NotCardOrEan,
  ServiceUnavailable,
}

// Characters Keys
export const MAP_SUB_CATEGORY = 'map_subcategory_';
export const STYLE_NAME = 'name_';

// Authorization buttons
export const GOOGLE = 'google';
export const FACEBOOK = 'facebook';
export const APPLE = 'apple';
export const EMAIL = 'email';

// Price range for VH
export const PRICE_RANGE = {
  [PRODUCT_CATEGORY_BEER]: [
    { level: 1, max: 2.99, min: 0 },
    { level: 2, max: 4.99, min: 3 },
    { level: 3, max: 6.99, min: 5 },
    { isMax: true, level: 4, min: 7 },
  ],
  [PRODUCT_CATEGORY_COFFEE]: [
    { level: 1, max: 5.99, min: 0 },
    { level: 2, max: 10.99, min: 6 },
    { level: 3, max: 20.99, min: 11 },
    { isMax: true, level: 4, min: 21 },
  ],
  [PRODUCT_CATEGORY_WINE]: [
    { level: 1, max: 5.99, min: 0 },
    { level: 2, max: 10.99, min: 6 },
    { level: 3, max: 20.99, min: 11 },
    { isMax: true, level: 4, min: 21 },
  ],
  default: [
    { level: 1, max: 4.99, min: 0 },
    { level: 2, max: 9.99, min: 5 },
    { level: 3, max: 19.99, min: 10 },
    { isMax: true, level: 4, min: 20 },
  ],
} as const;
export const EXPERIENCES_PRICE_RANGE = [
  { level: 1, max: 30, min: 0 },
  { level: 2, max: 50, min: 31 },
  { level: 3, max: 100, min: 51 },
  { isMax: true, level: 4, min: 101 },
];

// APP Variants
export const VH_VARIANTS = {
  BEER: 'beer',
  COFFEE: 'coffee',
  DANGER: 'danger',
  DARK: 'dark',
  INFO: 'info',
  LIGHT: 'light',
  LINK: 'link',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  TRANSPARENT: 'transparent',
  WARNING: 'warning',
  WINE: 'wine',
} as const;

export const MODALS = {
  DISCOVERY_QUIZ_MODAL: 'discoveryQuizModal',
  DOWNLOAD_APP_MODAL: 'downloadAppModal',
  FOOD_PREFERENCES_MODAL: 'foodPreferencesModal',
  MANAGE_MODAL: 'manageModal',
  TERMS_OF_SERVICE_BASIC_MODAL: 'termsOfServiceBasicModal',
  THIRD_PARTY_CONNECT_MODAL: 'thirdPartyConnectModal',
} as const;

// Taste Path
export const DEFAULT_MAX_LENGTH_TASTE_PATH_PER_CATEGORY = 3;

// Discovery Quiz
export const DISCOVER_QUIZ_STEP_START_QUIZ = 0;
export const DISCOVER_QUIZ_STEP_ANSWER_AROMA = 1;
export const DISCOVER_QUIZ_STEP_ANSWER_TASTE = 2;
export const DISCOVER_QUIZ_TASTE_ATTRIBUTE = 'taste';
export const DISCOVER_QUIZ_AROMAS_ATTRIBUTE = 'aromas';
export const DISCOVERY_QUIZ_RANDOM_PRODUCTS_COUNT = 2;

// Product Lists
export const PRODUCT_LIST_WISHLIST = 'wishlist';

export const IS_FROM_CATALOG_PAGE_URL_PARAM = 'isFromCatalogPage';

// Taste Id
export const JOURNAL_PRODUCT_VARIANT = 'product';
export const JOURNAL_PLACES_VARIANT = 'places';
export const JOURNAL_PANEL_PLACES_FILTER = 'places';
export const JOURNAL_PANEL_LOCATION_FILTER = 'location';

export type TJournalVariant = typeof JOURNAL_PRODUCT_VARIANT | typeof JOURNAL_PLACES_VARIANT;
export type TJournalPlacesPanelFilter = typeof JOURNAL_PANEL_PLACES_FILTER | typeof JOURNAL_PANEL_LOCATION_FILTER;

export const FLAG_MEDIA_DOMAIN = `${ENV_MEDIA_DOMAIN}/country_flags/`;

// Banners
export const BANNER_POSITIONS = {
  WIDGET_LAUNCHER: 'R00024',
  HOME: 'R00003',
  PRODUCT_FEEDBACK: 'R00023',
  EMAIL_REGISTRATION: 'R00001',
  CATALOG: 'R00014',
  SURVEY_QUESTION_PAGE: 'R00028',
} as const;

export type TBannerPositions = (typeof BANNER_POSITIONS)[keyof typeof BANNER_POSITIONS];

export const BANNER_ICONS = {
  bookmark: 'bookmark',
  box: 'box',
  cart: 'cart',
  compass: 'compass',
  doc: 'doc',
  filter: 'filter',
  'finger-print': 'finger-print',
  'fork-knife': 'fork-knife',
  list: 'list',
  promo: 'promo',
  rocket: 'rocket',
  save: 'save',
  star: 'star',
} as const;

// Root elements
export const ROOT_ELEMENT_ID = 'root-element';

export const ROOT_ELEMENT_VARIANT = {
  KIOSK: 'kiosk',
} as const;

// Retailer colors
export const COLOR_PRIMARY = '--color-primary-';
export const COLOR_SECONDARY = '--color-secondary-';
export const COLOR_PRODUCT = '--color-product-';

const RGB_WHITE: number[] = [255, 255, 255];
const RGB_BLACK: number[] = [0, 0, 0];

export const COLOR_BLEND_STEPS: Record<TColorShadeKey, [number[], number]> = {
  '25': [RGB_WHITE, 0.96],
  '50': [RGB_WHITE, 0.8],
  '100': [RGB_WHITE, 0.64],
  '200': [RGB_WHITE, 0.48],
  '300': [RGB_WHITE, 0.32],
  '400': [RGB_WHITE, 0.16],
  '500': [RGB_WHITE, 0], // this is the base color
  '600': [RGB_BLACK, 0.16],
  '700': [RGB_BLACK, 0.32],
  '800': [RGB_BLACK, 0.48],
  '900': [RGB_BLACK, 0.64],
};

export const DEFAULT_PRODUCT_CATEGORY_COLORS = {
  [PRODUCT_CATEGORY_BEER]: { '500': '#EB7F00' },
  [PRODUCT_CATEGORY_BREAD]: { '500': '#E2C100' },
  [PRODUCT_CATEGORY_CANDY]: { '500': '#B8531A' },
  [PRODUCT_CATEGORY_CHOCOLATE]: { '500': '#B8531A' },
  [PRODUCT_CATEGORY_COFFEE]: { '500': '#150400' },
  [PRODUCT_CATEGORY_DIGESTIF]: { '500': '#6E252E' },
  [PRODUCT_CATEGORY_OIL]: { '500': '#BBCB00' },
  [PRODUCT_CATEGORY_TEA]: { '500': '#59D2B1' },
  [PRODUCT_CATEGORY_WINE]: { '500': '#9E005D' },
  default: { '500': '#9E005D' },
};
